require("../sass/style.scss");

require("../../fonts/fontello/css/fontello.css");

require("./vendor/animatedBrackets.js");
require("./vendor/clip_carousel.js");
require("./vendor/collapse.js");
require("./vendor/dropdown.js");
require("./vendor/jquery.flipster.min.js");
require("./vendor/jquery.isonscreen.js");
// require("./vendor/packery-mode.pkgd.min.js");
require("./vendor/isotope.pkgd.min.js");
// require("./vendor/jquery-modal-video.min.js");
require("./vendor/lightgallery.js");
require("./vendor/parallax.js");
require("./vendor/parallaxContent.js");
require("./vendor/slick.min.js");
require("./vendor/tab.js");
require("./vendor/TweenMax.min.js");
// require("./vendor/vue.min.js");
// require("./vendor/vue-carousel-3d.min.js");


require("./custom/custom.es6");
require("./custom/customBlog.es6");
require("./custom/featured-videos-vue.es6");
require("./custom/ProtectedDownloads.es6");
require("./custom/transition.js");
require("./custom/progress-btn.es6");
// require("./custom/anchors.es6");

(function ($) {
    $(document).ready(function () {
        // Hide Recaptcha
        if ($(".grecaptcha-badge").length > 0) {
            $(".grecaptcha-badge").each(function () {
                $(".grecaptcha-badge").css("opacity", "0");
            });
        }

        if ($(".review_2022_events").length > 0) {
            require("./custom/section-review_2022.es6");
        }

        if ($(".review_2022_cards_tabs").length > 0) {
            require("./custom/section-review_2024_cards_tabs.es6");
        }

        if ($(".blog-hero").length > 0) {
            require("./custom/blog-hero.es6");
        }

        if ($(".resources").length > 0) {
            require("./custom/section-resources-overview.es6");
        }

        if ($(".portfolio-projects").length > 0) {
            require("./custom/section-portfolio_of_projects.es6");
        }
    });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/entry.es6